import React from 'react';

function Footer() {
  return (
    <footer id="about" className="bg-[#0A0F1F] text-gray-400 py-12">
      <div className="container mx-auto px-6">
        {/* Footer Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Left Section: About and Follow Us */}
          <div className="text-left"> {/* Add text-left to align content to the left */}
            {/* About Section */}
            <p className="text-4xl font-bold bg-gradient-to-r from-white to-[#0097B2] bg-clip-text text-transparent">
              NIB ERP
            </p>
            <p className="mb-6 mt-4">
              NIB ERP is your go-to platform for seamless, smart, and efficient business management. Discover tools designed to optimize operations and provide real-time insights.
            </p>

            {/* Follow Us */}
            <h3 className="text-lg text-white font-bold mb-4">Follow Us</h3>
            <div className="flex space-x-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-yellow-400 transition text-2xl"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-yellow-400 transition text-2xl"
              >
                <i className="fab fa-twitter"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-yellow-400 transition text-2xl"
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-yellow-400 transition text-2xl"
              >
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>


          {/* Right Section: Quick Links and Contact */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Quick Links Section */}
            <div>
              <h3 className="text-xl text-white font-bold mb-4">Quick Links</h3>
              <ul>
                <li className="mb-2">
                  <a href="/features" className="hover:text-yellow-400 transition">Features</a>
                </li>
                <li className="mb-2">
                  <a href="/pricing" className="hover:text-yellow-400 transition">Pricing</a>
                </li>
                <li className="mb-2">
                  <a href="/about" className="hover:text-yellow-400 transition">About Us</a>
                </li>
                <li>
                  <a href="/contact" className="hover:text-yellow-400 transition">Contact</a>
                </li>
              </ul>
            </div>

            {/* Contact Section */}
            <div>
              <h3 className="text-xl text-white font-bold mb-4">Contact Us</h3>
              <ul>
                <li className="mb-2">
                  
      <i className="fas fa-envelope text-yellow-400 mr-2"></i>
<a href="mailto:info@easyerp.com" className="hover:text-yellow-400 transition">info@niberp.com.et</a>
                </li>
                <li className="mb-2">
                  
      <i className="fas fa-phone-alt text-yellow-400 mr-2"></i> <a href="tel:+251 941228146" className="hover:text-yellow-400 transition">+251 941228146</a>
                </li>
                <li>
                  
      <i className="fas fa-map-marker-alt text-yellow-400 mr-2"></i> Addis Ababa, Ethiopia
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="text-center text-gray-600 mt-12 border-t border-gray-700 pt-6">
          <p>&copy; {new Date().getFullYear()} NIB Technologies. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
